var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:['back-arrow', _setup.isVisible && 'back-arrow-visible'],on:{"click":_setup.goBack}},[_c('BaseIcon',{staticClass:"arrow",attrs:{"name":"arrow-longer-left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }